var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"yume-pages",class:{'patient-page': _vm.moduleName === 'patient', 'doctor-page': _vm.moduleName === 'doctor'},attrs:{"id":"app"}},[_c('api-loader'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }